// @flow
import get from 'lodash/get';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';

import { setSearchParams } from '../../../Serp/actions';
import {
  existsGeolocationParam,
  existsWhatParam,
  getWhatLabel,
  getWhereLabel,
} from '../../../Serp/selectors';
import DisambiguationTagsList from '.';
import { trackEvent } from '../../../tracking/actions';
import { disambiguationListRemoveFilterClickEvent } from '../../../tracking/events';
import { activateUserFilterInteraction } from '../../../Serp/components/Filters/shared/actions';

type MapStateToProps = {
  what: string,
  where: string,
  isShowed: boolean,
};

export function mapDispatchToProps(dispatch: Dispatch<*>) {
  return {
    onWhatRemove(searchParams: Object) {
      const newSearchParameters = {
        ...searchParams,
        filters: { ...searchParams.filters, category: undefined },
        what_d: '',
        whatAccented: '',
        isSeoUrl: false,
        isSemUrl: false,
        routeName: 'serp_search',
        pageName: 'serp',
        page: 1,
      };

      // Test AB [PROD-283] - Disambiaguation tracking
      dispatch(trackEvent(disambiguationListRemoveFilterClickEvent()));

      dispatch(activateUserFilterInteraction());
      dispatch(setSearchParams(newSearchParameters, false));
    },
    onWhereRemove(searchParams: Object) {
      const what = get(searchParams, 'what_d');
      let newSearchParameters = {
        ...searchParams,
        filters: {
          ...searchParams.filters,
          city: undefined,
          city_area: undefined,
          region: undefined,
        },
        where: undefined,
        isSeoUrl: false,
        isSemUrl: false,
        routeName: 'serp_search',
        pageName: 'serp',
        page: 1,
      };

      if (typeof what !== 'string' || what.length === 0) {
        newSearchParameters = {
          ...newSearchParameters,
          what_d: get(searchParams, ['filters', 'category']),
        };
      }

      // Test AB [PROD-283] - Disambiaguation tracking
      dispatch(trackEvent(disambiguationListRemoveFilterClickEvent()));

      dispatch(activateUserFilterInteraction());
      dispatch(setSearchParams(newSearchParameters, false));
    },
  };
}

export function mapStateToProps(state: Object): MapStateToProps {
  return {
    what: getWhatLabel(state),
    where: getWhereLabel(state),
    isShowed: existsGeolocationParam(state) && existsWhatParam(state),
  };
}

const DisambiguationTagsListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DisambiguationTagsList);

export default DisambiguationTagsListContainer;



// WEBPACK FOOTER //
// ./app/common/Lists/DisambiguationTagsList/container.js